import React from "react";
import "./index.css";

const InfoBlock = (props) => {
    const { title, children, centered, href } = props;
    const titleClassName = centered ? `title has-text-centered` : `title`;

    return (
        <div className="info-block transitioned-fade-in">
            <div className="container">
                {
                    href 
                        ?   <a href={href} target="_blank"> <h1 className={titleClassName}>{title}</h1> </a> 
                        :   title
                                ?   <h1 className={titleClassName}>{title}</h1>
                                :   null
                }
                
                {children}
            </div>
        </div>
    );
}

export default InfoBlock;
